export default __webpack_public_path__ + "static/media/people.5b587bcc.jpg";